import { CalendarDateTime, CalendarDate } from '@internationalized/date';
export * from '@internationalized/date';
export function stringToDate(value, withTime) {
    if (!value)
        return value;
    const parser = (isoStr) => {
        // парсеры строковых дат из @internationalized/date падают на датах,
        // которые в ISO получают 0000 год при переводе в UTC из-за разницы во времени (например 1/1/1)
        // потому переводим ерез нативную дату
        const date = new Date(isoStr);
        if (withTime) {
            // тут будет дата и время в текущей таймзоне
            return new CalendarDateTime(date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
        }
        // тут будет дата в текущей таймзоне
        return new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    };
    if (typeof value === 'string')
        return parser(value);
    return {
        start: parser(value.start),
        end: parser(value.end),
    };
}
export function dateToString(value, timeZone) {
    return value.toDate(timeZone).toISOString();
}
export function dateRangeToString(range, timeZone) {
    return {
        start: dateToString(range.start, timeZone),
        end: dateToString(range.end, timeZone),
    };
}
